import {
  DimeButton,
  DimeCard,
  DimeCardDescription,
  DimeCardHeader,
  DimeCardTitle,
} from '@nudool/design-system';
import { createFileRoute, Link } from '@tanstack/react-router';
import { RouteGuard } from '../../../lib/route-guard.js';
import { EventsSectionTabs } from '../../../modules/events/events-section-tabs.js';
import { EventTemplatesList } from '../../../modules/events/templates/event-templates-list.js';

export const Route = createFileRoute('/events/templates/')({
  component: EventTemplatesPage,
});

// eslint-disable-next-line react-refresh/only-export-components -- TanStack Router requires co-exporting Route with the component
function EventTemplatesPage() {
  return (
    <RouteGuard route="/events/templates">
      <DimeCard borderless className="gap-0 py-0">
        <DimeCardHeader className="mb-4 px-0">
          <div className="flex items-center justify-between">
            <DimeCardTitle className="flex items-center gap-2 text-base">Events</DimeCardTitle>
            <DimeButton size="sm" variant="outline" asChild>
              <Link to="/events/templates/new">New template</Link>
            </DimeButton>
          </div>
          <DimeCardDescription className="text-sm">
            Event types your team can start new events from.
          </DimeCardDescription>
        </DimeCardHeader>
        <div className="flex flex-col gap-4">
          <EventsSectionTabs active="templates" />
          <EventTemplatesList />
        </div>
      </DimeCard>
    </RouteGuard>
  );
}
